import actionTypes from './actionTypes';

export const changeUserName = (userName) => (dispatch) => {
    dispatch({
        type: actionTypes.USERNAME_CHANGED,
        userName: userName.trim()
    });
};

export const changePassword = (password) => (dispatch) => {
    dispatch({
        type: actionTypes.PASSWORD_CHANGED,
        password
    });
};

export const changeProofOfOwnershipType = (proofOfOwnershipType) => (dispatch) => {
    dispatch({
        type: actionTypes.PROOF_OF_OWNERSHIP_TYPE_CHANGED,
        proofOfOwnershipType
    });
};

export const changeProofOfOwnershipValue = (proofOfOwnershipValue) => (dispatch) => {
    dispatch({
        type: actionTypes.PROOF_OF_OWNERSHIP_VALUE_CHANGED,
        proofOfOwnershipValue
    });
};

export const navigateBack = () => {
    return {
        type: actionTypes.NAVIGATE_BACK
    };
};

export const showRadioMobile = () => (dispatch) => {
    dispatch({
        type: actionTypes.SHOW_RADIO_MOBILE
    });
};

export const submit = () => async (dispatch, getState) => {
    const { configuration: { connectParams, apiService }, accountConnector } = getState();

    if (accountConnector.isProcessing) {
        return;
    }

    // Show the loading indicator.
    dispatch({
        type: actionTypes.SUBMIT_IN_PROGRESS
    });

    const accountInformation = {
        userName: accountConnector.userName.trim(),
        password: accountConnector.password.trim(),
        proofType: accountConnector.proofOfOwnershipType,
        proof: accountConnector.proofOfOwnershipValue,
        shopId: 0
    };

    apiService.validateAccountInformation(accountInformation, connectParams.rewardsKey).then(compositionResult => {
        // Hide the loading indicator when api call is done.
        dispatch({
            type: actionTypes.SUBMIT_COMPLETED
        });

        if (compositionResult.success(compositionResult)) {
            dispatch({
                type: actionTypes.AUTHORIZATION_COMPLETE
            });
        } else {
            dispatch({
                type: actionTypes.AUTHORIZATION_FAILED,
                validationErrors: compositionResult.validationErrors
            });
        }
    });
};


// WEBPACK FOOTER //
// ./src/modules/account-connector/actions.js